import { EntityTypeConfigurationHelper, EntityTypeConfigurationModel } from '../../../../../../models/basics/basics.models';
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { autoinject } from "aurelia-dependency-injection";
import { NotificationClientService, NotificationType } from '../../../../../../services/basics/notification-client.service';
import { ValidationController, ValidationControllerFactory, ValidationRules } from 'aurelia-validation';
import { CustomValidationRenderer } from '../../../../../../client-validation-system/custom-validation-renderer';
import { CustomerSubscriptionModel } from "../../../../../../models/customers/customer-subscription.models";
import { ValidationsClientService } from "../../../../../../services/validations/validations-client.service";
import { ChangeCustomerCompaniesResponse, ChangeCustomerCompany } from '../../../../../../models/vessels/customer-company.models';
import { CustomerCompaniesService } from '../../../../../../services/vessels/customer-companies.service';
import { CompanyService } from '../../../../../../services/modules/company-client.service';
import { SubscriptionHelper } from '../../helpers/subscription-helper';

@autoinject
export class ChangeCompanySubscriptionDialog {

    private _onSaved: () => void;
    private validator: ValidationController;
    public confirmation: boolean;
    public companyEntityTypeConfigurationModel: EntityTypeConfigurationModel[];
    public fromCompany: any;
    public selectedCompany: any;
    public customerSubscription: CustomerSubscriptionModel;
    public customerId: number;

    constructor(private dialogClientService: DialogClientService, private entityTypeConfigurationHelper: EntityTypeConfigurationHelper,
        private customerCompaniesService: CustomerCompaniesService, validationControllerFactory: ValidationControllerFactory,
        private notificationClientService: NotificationClientService, private companyService: CompanyService,
        private validationsClientService: ValidationsClientService, private subscriptionHelper: SubscriptionHelper) {

        this.validator = validationControllerFactory.createForCurrentScope();
        this.validator.addRenderer(new CustomValidationRenderer());
        this.companyEntityTypeConfigurationModel = this.entityTypeConfigurationHelper.getConfigurationByKey(["BasicCompanySearch"]);
        
    }

    activate(model: { onSaved: () => void , companyId: number, customerSubscription: CustomerSubscriptionModel, customerId: number }) {
        this.companyService.getCompany(model.companyId).then(x => {
            this.fromCompany = x.company;
        });
        this._onSaved = model.onSaved;
        this.companyService.getCompany(model.companyId).then(x => {
            this.fromCompany = x.company;
        });
        this.customerSubscription = model.customerSubscription;
        this.customerId = model.customerId;
    }

    cancel() {
        this.dialogClientService.hide();
    }

    async save() {
        if (this.fromCompany.id === this.selectedCompany?.id) {
            this.notificationClientService.show("Cannot change the same company", "", NotificationType.Error);
            return;
        }

        this.setRules();
        try {
            const validationResult = await this.validator.validate();
            if (validationResult.valid) {

                const changeCustomerCompanies: ChangeCustomerCompany[] = [];
                changeCustomerCompanies.push({
                    fromCompanyId: this.fromCompany.id,
                    toCompanyId: this.selectedCompany.id
                } as ChangeCustomerCompany);

                await this.customerCompaniesService.changeCustomerCompanies({
                    changeCustomerCompanies: changeCustomerCompanies,
                    customerId: this.customerId
                }).then((response: ChangeCustomerCompaniesResponse) => {
                    if (response.validationResult && response.validationResult.hasError) {
                        this.validationsClientService.showValidationErrors(response.validationResult);
                    } else {
                        this.dialogClientService.hide();
                        this.notificationClientService.show("Company changed successfully!", "", NotificationType.Success);
                        this._onSaved();
                    }
                });
            }
        } catch (e) {
            console.error("Failed to change customer companies", e);
        }
    }

    companySelected(index: number, event: any) {
        if (event.detail.selectedEntity) {
            this.selectedCompany = event.detail.selectedEntity;
        }
    }

    removeSelectedCompany() {
        this.selectedCompany = null;
    }

    setRules() {
        ValidationRules
            .ensure<ChangeCompanySubscriptionDialog, boolean>(x => x.confirmation)
            .required()
            .withMessage("Confirmation is required")
            .on(this);

        this.validator.reset();
        this.validator.addObject(this);
    }

    upgradeSubscription() {
        const url: string = this.subscriptionHelper.getUpgradeSubscriptionUrl();
        window.open(url, "_blank");
    }
}